interface FieldConfig {
  name: string;
  schema: string;
  translate: string;
}

const fieldConfig: Record<number, FieldConfig> = {
  1: {
    name: 'Название',
    schema: 'name',
    translate: 'заполните поле название наряда'
  },
  2: {
    name: 'Тип наряда',
    schema: 'taskType',
    translate: 'укажите тип наряда'
  },
  3: { name: 'Объект', schema: 'asset', translate: 'выберите объект' },
  4: { name: 'Участок', schema: 'department', translate: 'укажите участок' },
  5: {
    name: 'Исполнитель',
    schema: 'employees',
    translate: 'назначьте исполнителей'
  },
  6: {
    name: 'Начало работы (План)',
    schema: 'plannedStartDate',
    translate: 'укажите дату и время начала работы(план)'
  },
  7: {
    name: 'Начало работы (факт)',
    schema: 'actualStartDate',
    translate: 'укажите дату и время начала работы(факт)'
  },
  8: {
    name: 'Завершение работы (План)',
    schema: 'plannedEndDate',
    translate: 'укажите дату и время окончания работы(план)'
  },
  9: {
    name: 'Завершение работы (Факт)',
    schema: 'actualEndDate',
    translate: 'укажите дату и время окончания работы(факт)'
  },
  10: {
    name: 'Описание',
    schema: 'description',
    translate: 'заполните поле описание'
  },
  11: {
    name: 'Вложения',
    schema: 'attainments',
    translate: ''
  },
  12: {
    name: 'Плановые работы',
    schema: 'plannedOperations',
    translate: 'укажите плановые работы'
  },
  13: {
    name: 'Фактические работы',
    schema: 'actualOperations',
    translate: 'укажите фактические работы'
  },
  14: {
    name: 'Интервал',
    schema: 'interval',
    translate: 'укажите интервал'
  }
};

export function getFieldName(fieldType: number): string {
  return fieldConfig[fieldType]?.name || '';
}

export function getFieldNameSchema(fieldType: number): string {
  return fieldConfig[fieldType]?.schema || '';
}

export function getFieldNameTranslate(fieldName: string): string {
  return (
    Object.values(fieldConfig).find((config) => config.schema === fieldName)
      ?.translate || ''
  );
}
